<template>
  <div class="homeRaiseDetail HomeContainer">
    <div class="detailContainer" v-if="detail" key="detail">
      <div class="mainContainer">
        <div class="imgContainer">
          <el-image
            class="mainImg"
            :src="detail.img_array[imgIndex]"
            fit="contain"
            :preview-src-list="detail.img_array"
          ></el-image>
          <div class="imgList">
            <el-image
              :src="item"
              fit="cover"
              :preview-src-list="detail.img_array"
              :class="{ selected: imgIndex == index }"
              v-for="(item, index) of detail.img_array"
              :key="index"
              @mouseenter="imgIndex = index"
            ></el-image>
          </div>
        </div>

        <div class="basicContainer">
          <div class="title">
            {{ detail.title }}
          </div>
          <div class="price">
            {{ detail.specification_amount[0].price }}{{l("元")}}/{{
              detail.specification_amount[0].unit
            }}
          </div>

          <div class="progressContainer">
            <div class="progressBar">
              <div
                class="innerBar"
                :style="{
                  width: (detail.rate_amount / detail.amount) * 100 + '%',
                }"
              ></div>
            </div>
            <div class="rate_amount">
              <span class="color-warning"
                >{{ detail.rate_amount
                }}{{ detail.specification_amount[0].unit }}</span
              >/{{ detail.amount }}{{ detail.specification_amount[0].unit }}
            </div>
          </div>
          <div class="materialInfo">
            <div class="line">
              {{l("品名")}}：
              {{ $store.getters.getCategory(detail.category_id) }}
              {{ detail.child_category }}
            </div>

            <div class="line">{{l("材料")}}：{{ detail.material }}</div>
            <div class="line">
              {{l("规格")}}：{{ detail.specification_amount[0].specification }}
            </div>
            <div class="line">{{l("钢厂")}}：{{ detail.steel_mill }}</div>
          </div>
          <el-button
            v-if="detail.status == 1"
            key="status1"
            type="warning"
            style="width: 130px; height: 40px; margin-top: 25px"
            @click="doBusiness"
          >
            {{ detail.business_action_code ? l("修改我的拼单") : l("参与拼单") }}
          </el-button>
          <el-button
            v-else-if="detail.status == 2"
            key="status2"
            type="warning"
            style="width: 130px; height: 40px; margin-top: 25px"
            disabled
            >{{l("已结束")}}</el-button
          >
        </div>

        <div class="targetContainer">
          <div>
            {{l("拼成目标")}}
            <span
              class="color-warning"
              style="font-size: 30px; margin: 0 4px"
              >{{ detail.amount }}</span
            >
            {{ detail.specification_amount[0].unit }}
          </div>
          <div style="color: #666; margin-top: 10px">
            {{l("起拼量")}}：{{ detail.start_amount
            }}{{ detail.specification_amount[0].unit }}
          </div>
        </div>
      </div>
      <div class="otherInfo">
        <div class="title">{{l("其他信息")}}</div>
        <div class="infoLines">
          <div class="line">
            {{l("计重方式")}}：
            {{
              $utils.listFilter(
                $store.state.basicInfo.weight_methodList,
                detail.weight_method
              )
            }}
          </div>

          <div class="line">
            {{l("提供质保书")}}：{{ detail.have_warranty ? l("是") : l("否") }}
          </div>

          <div class="line">
            {{l("发货地")}}：
            {{ detail.address }}
          </div>
          <div class="line">
            {{l("截止日期")}}：
            {{ detail.expire_time.slice(0, 10) }}
          </div>
        </div>
      </div>

      <div v-if="detail.description" class="descriptionContainer">
        <div class="title">{{l("补充说明")}}</div>
        <div class="description" v-html="detail.description"></div>
      </div>
    </div>

    <div v-if="showEmpty" key="empty" class="emptyContainer">
      <el-empty>
        <div slot="description">
          {{l("抱歉，该拼单不存在或已下架。")}}
        </div>
      </el-empty>
    </div>

    <BusinessDialog
      ref="businessDialog"
      :business_detail="detail"
      @submitDialog="businessCallback"
    />
  </div>
</template>
<script>
import BusinessDialog from "@/components/common/BusinessDialog";

export default {
  name: "HomeRaiseDetail",
  components: { BusinessDialog },
  data() {
    return {
      detail: null,
      showEmpty: false,
      imgIndex: 0,
    };
  },
  created() {
    this.getRaiseDetail();
  },
  methods: {
    getRaiseDetail() {
      this.axios
        .get(`/api/visitor_raise/${this.$route.params.code}/`)
        .then((data) => {
          console.log("data", data);
          data.img_array = JSON.parse(data.img_array);
          if (data.img_array.length > 5) {
            data.img_array.length = 5;
          }
          // data.rate_amount = 50000;
          this.detail = data;
        })
        .catch(() => {
          this.showEmpty = true;
        });
    },
    doBusiness() {
      this.$refs.businessDialog.Show({
        module: "raise",
      });
    },
    businessCallback(formData) {
      console.log("formData", formData);
      if (formData.code) {
        this.axios
          .put(`/api/business_action/${formData.code}/`, formData)
          .then(() => {
            this.getRaiseDetail()//更新拼单进度
          });
      } else {
        this.axios.post(`/api/business_action/`, formData).then((res) => {
           this.detail.business_action_code = res.code;//更新business_action_code
            this.getRaiseDetail()//更新拼单进度
        });
      }
    },
  },
};
</script>


<style scoped lang="scss">
.homeRaiseDetail {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  .detailContainer {
    // width: 950px;
    flex-grow: 1;
    margin-right: 10px;
    box-sizing: border-box;
    padding: 35px 30px 50px;
    background-color: #fff;
  }
  .mainContainer {
    display: flex;
    align-items: flex-start;
    position: relative;
    padding-bottom: 30px;
    border-bottom: 1px solid $borderPlainColor;
  }
}

.imgContainer {
  $mainImgWidth: 270px;
  width: $mainImgWidth;
  border: 1px solid $borderColor;

  .mainImg {
    width: $mainImgWidth;
    height: $mainImgWidth;
  }
  .imgList {
    display: flex;
    justify-content: flex-start;
    margin-top: 3%;

    .el-image {
      width: 50px;
      height: 50px;
      opacity: 0.6;
      box-sizing: border-box;
      cursor: pointer;
      & + .el-image {
        margin-left: 5px;
      }
      &.selected {
        opacity: 1;
        border: 2px solid $warningColor;
      }
    }
  }
}

.basicContainer {
  width: 800px;
  margin-left: 56px;
  box-sizing: border-box;
  .title {
    width: 550px;
    font-size: 20px;
    font-weight: bold;
  }
  .price {
    color: $warningColor;
    font-size: 24px;
    margin-top: 20px;
  }

  .progressContainer {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .progressBar {
      // max-width: 650px;
      flex-grow: 1;
      flex-shrink: 1;
      height: 14px;
      background: $borderPlainColor;
      border-radius: 8px;
      margin-right: 50px;

      overflow: hidden;
      .innerBar {
        border-radius: 8px;
        background: $warningColor;
        height: 100%;
      }
    }
    .rate_amount {
      flex-shrink: 0;
      letter-spacing: 0.5px;
      color: #999;
    }
  }
  .materialInfo {
    margin-top: 30px;
    .line {
      display: flex;
      margin-bottom: 12px;
      line-height: 18px;
      height: 18px;
    }
  }
}

.targetContainer {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
}

.otherInfo {
  .title {
    padding-left: 8px;
    border-left: 2px solid $warningColor;
    line-height: 14px;
    height: 14px;
    margin-top: 45px;
    font-weight: bold;
  }
  .infoLines {
    margin: 30px 0;
    .line {
      display: flex;
      margin-top: 10px;
    }
  }
}
.descriptionContainer {
  border-top: 1px solid $borderPlainColor;
  box-sizing: border-box;
  .title {
    line-height: 14px;
    height: 14px;
    margin-top: 30px;
    font-weight: bold;
  }
  .description {
    margin-top: 20px;
    width: 100%;
    white-space: pre-line;
  }
}

.emptyContainer {
  flex-grow: 1;
  margin-right: 10px;

  background: #fff;
  box-sizing: border-box;
  padding: 100px 0 120px;
}
</style>

